import * as React from 'react';
import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppState } from '@app/store';
import './style.scss';
import { CatalogTitleProps } from './CatalogTitleProps';

const CatalogTitle: React.FC<CatalogTitleProps> = ({
  catalogueType,
  handleClick,
}) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const isFirstTypeChange = useRef(true);
  const currentTitle =
    catalogueType === 'biznes'
      ? 'Каталог услуг для бизнеса'
      : 'Каталог услуг для жителей';
  const switchTitle =
    catalogueType === 'biznes'
      ? 'Каталог услуг для жителей'
      : 'Каталог услуг для бизнеса';

  useEffect(() => {
    if (isFirstTypeChange.current) {
      isFirstTypeChange.current = false;
      return undefined;
    }

    const focusTimer = window.setTimeout(() => {
      titleRef.current?.focus({ preventScroll: true });
    }, 0);

    return () => {
      window.clearTimeout(focusTimer);
    };
  }, [catalogueType]);

  return (
    <div className="mos-catalog_title">
      <h1 key={catalogueType} ref={titleRef} tabIndex={-1}>
        {currentTitle}
      </h1>
      <span className="mos-catalog_link-separator" aria-hidden="true">
        &nbsp;/&nbsp;
      </span>
      <Link
        to={`${catalogueType === 'biznes' ? '/uslugi/' : '/biznes/'}`}
        className="mos-catalog_link"
        aria-label={switchTitle}
        onClick={() => {
          handleClick(catalogueType === 'biznes' ? '/uslugi' : '/biznes');
        }}
      >
        <span className="mos-catalog_visually-hidden">{switchTitle}</span>
        {catalogueType === 'biznes' && (
          <span aria-hidden="true">
            <span className="hidemob">для</span>
            &nbsp;жителей
          </span>
        )}
        {catalogueType === 'uslugi' && (
          <span aria-hidden="true">
            <span className="hidemob">для</span>
            &nbsp;бизнеса
          </span>
        )}
      </Link>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  catalogueType: state.catalogue.type,
});

const ConnectedCatalogTitle = connect(mapStateToProps, {})(CatalogTitle);

export default ConnectedCatalogTitle;
